<app-system-message></app-system-message>

<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  <section [ngClass]="theme.getThemeClass()" class="card bg-light">
    <article [ngClass]="theme.getThemeClass()" class="card-body mx-auto article">

      <h4 [ngClass]="theme.getThemeClass()" class="card-title mt-0 text-center">Maintenance & XBee Logs</h4>

      <!-- Header -->
      <form [formGroup]="head" class="mb-3">
        <div class="row g-2 align-items-end">
          <div class="col-12 col-md-3">
            <label class="form-label">Thing Name</label>
            <input class="form-control" formControlName="thing_name" placeholder="MWS-B01-123">
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label">Row Timestamp</label>
            <input readonly style="width: 240px;" class="form-control" type="datetime-local" formControlName="timestamp" appEpochDatetimeLocal>
          </div>

          <div class="col-12 col-md-3" >
            <!-- USER ID maintenance log-->
            <input type="hidden" class="form-control" formControlName="user_sub_dml">
          </div>

          <div class="col-12 col-md-3" >
            <!-- USER ID xbee log -->
            <input type="hidden" class="form-control" formControlName="user_sub_xcl">
          </div>
        </div>

        <div class="mt-2 d-flex gap-2">
          <button class="btn btn-primary" type="button" (click)="prefillFromLatest()" [disabled]="loading || head.invalid">
            Prefill from latest
          </button>
          <button class="btn btn-primary btn-save" type="button" (click)="submitCreate()" [disabled]="loading || head.invalid">
            Save Snapshot (both tables)
          </button>
        </div>

        @if (errorMsg) {<div class="text-danger mt-2">{{ errorMsg }}</div>}
      </form>

      <hr>

      <!-- Tabs -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='maintenance'" (click)="setTab('maintenance')" role="button">
            Maintenance Log
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeTab==='xbee'" (click)="setTab('xbee')" role="button">
            XBee Config Log
          </a>
        </li>
      </ul>

      <!-- Maintenance Tab -->
      @if (activeTab==='maintenance') {
      <div class="pt-3">
        <form [formGroup]="maintenance">
          @for (key of maintenanceKeys; track key) {
          <div class="row g-2">
            <div class="col-12 col-md-6">
              <label class="form-label text-capitalize">{{ key.replace('_',' ') }}</label>
              <input class="form-control" [formControlName]="key" placeholder="{{ key }}">
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">{{ key }} timestamp</label>
              <input class="form-control" type="datetime-local" [formControlName]="key + '_timestamp'" appEpochDatetimeLocal>
            </div>
          </div>
          }
        </form>
      </div>
      }

      <!-- XBee Tab -->
      @if (activeTab==='xbee') {
      <div class="pt-3">
        <form [formGroup]="xbee">

          <h6 class="mt-2">Core Settings</h6>
          @for (key of xbeeMainKeys; track key) {
          <div class="row g-2">
            <div class="col-12 col-md-6">
              <label class="form-label text-capitalize">{{ key.replace('_',' ') }}</label>
              <input class="form-control" [formControlName]="key" placeholder="{{ key }}">
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">{{ key }} timestamp</label>
              <input class="form-control" type="datetime-local"
                     [formControlName]="(key === 'baud_rate' ? 'baud_timestamp' : key + '_timestamp')"
                     appEpochDatetimeLocal>
            </div>
          </div>
          }

          <h6 class="mt-3">DIO Pins</h6>
          @for (pin of dioPins; track pin) {
          <div class="row g-2">
            <div class="col-12 col-md-6">
              <label class="form-label">{{ pin }}</label>
              <input class="form-control" [formControlName]="pin" placeholder="{{ pin }}">
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">{{ pin }} timestamp</label>
              <input class="form-control" type="datetime-local" [formControlName]="pin + '_timestamp'" appEpochDatetimeLocal>
            </div>
          </div>
          }

          <h6 class="mt-3">Other</h6>
          @for (key of xbeeTailKeys; track key) {
          <div class="row g-2">
            <div class="col-12 col-md-6">
              <label class="form-label text-uppercase">{{ key }}</label>
              <input class="form-control" [formControlName]="key" placeholder="{{ key }}">
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label">{{ key }} timestamp</label>
              <input class="form-control" type="datetime-local" [formControlName]="key + '_timestamp'" appEpochDatetimeLocal>
            </div>
          </div>
          }
        </form>
      </div>
      }

    </article>
  </section>
</div>
